import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Service } from '../models/service.model';
import * as globals from '../training/globals';

const connectBaseUrl = `${environment.apis.connect}/${globals.CONFIGURATIONS}`;
const cdsBaseUrl = `${environment.apis.cds}/${globals.CONFIGURATIONS}`;

@Injectable({
  providedIn: 'root',
})

export class ConfigurationsService {
  constructor(
    private http: HttpClient) { }

  getConnectEnvVariables(): Observable<any> {
    return this.http.get(`${connectBaseUrl}/${globals.GET_ENVVARIABLES}`);
  }

  getConnectEnvVariable(name: string): Observable<string> {
    return this.http.get<string>(`${connectBaseUrl}/${globals.GET_ENVVARIABLE}/${name}`);
  }

  getConnectCreateServices(): Observable<Service[]> {
    return this.http.get<Service[]>(`${connectBaseUrl}/${globals.GET_CREATESERVICES}`);
  }

  updateConnectEnvVariables(data: any): Observable<any> {
    return this.http.post(`${connectBaseUrl}/${globals.UPDATE_ENVVARIABLES}`, data);
  }

  getCdsEnvVariables(): Observable<any> {
    return this.http.get(`${cdsBaseUrl}/${globals.GET_ENVVARIABLES}`);
  }

  updateCdsEnvVariables(data: any): Observable<any> {
    return this.http.post(`${cdsBaseUrl}/${globals.UPDATE_ENVVARIABLES}`, data);
  }

}
